// Einmal im App-Rahmen (in der Navigation) eingehängt: die Dialoge „Neuer Lead“ und „Leads importieren“, die von
// der Seitenleiste, dem Smart-View-Kopf, ⌘⇧L und der Befehlspalette geöffnet werden.
import { useCallback, useState } from "react";
import type { NeuerLeadEingabe } from "../../api/leadsNeu";
import { useDialogAuftrag, type DialogAuftrag } from "./dialogBus";
import { ImportDialog } from "./ImportDialog";
import { NeuerLeadDialog } from "./NeuerLeadDialog";

export function SmartViewDialoge() {
  const [neu, setNeu] = useState<{ offen: boolean; vorbelegung?: Partial<NeuerLeadEingabe> }>({ offen: false });
  const [importOffen, setImportOffen] = useState(false);
  const auftrag = useCallback((a: DialogAuftrag) => {
    if (a.art === "neu") setNeu({ offen: true, vorbelegung: a.vorbelegung });
    else setImportOffen(true);
  }, []);
  useDialogAuftrag(auftrag);
  return (
    <>
      <NeuerLeadDialog offen={neu.offen} vorbelegung={neu.vorbelegung} onSchliessen={() => setNeu((n) => ({ ...n, offen: false }))} />
      <ImportDialog offen={importOffen} onSchliessen={() => setImportOffen(false)} />
    </>
  );
}
